import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 7.91666V11.6667M10 13.75H10.0084M9.28098 2.89434L2.19316 14.9955C1.86777 15.551 2.26841 16.25 2.91223 16.25H17.0879C17.7317 16.25 18.1323 15.551 17.8069 14.9955L10.7191 2.89434C10.3972 2.34479 9.60286 2.34479 9.28098 2.89434ZM10.2084 13.75C10.2084 13.8651 10.1151 13.9583 10 13.9583C9.88499 13.9583 9.79171 13.8651 9.79171 13.75C9.79171 13.6349 9.88499 13.5417 10 13.5417C10.1151 13.5417 10.2084 13.6349 10.2084 13.75Z",
      stroke: "#FFB500",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }